import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';
import { miradorThemeProdem } from './mirador-theme/miradorThemeProdem';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Opera',
  type: 'manuscript',
  bodyClasses: 'mr-custom-series',
  sections: {
    top: [
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            theme: miradorThemeProdem,
            window: {
              allowClose: false,
              allowMaximize: false,
              allowFullscreen: true,
              allowTopMenuButton: false,
              defaultSidebarPanelWidth: 450,
              highlightAllAnnotations: true,
              defaultSideBarPanel: 'annotations',
              sideBarOpen: true,
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
            },
            workspaceControlPanel: {
              enabled: false,
            },
            id: 'mirador-container',
          },
        }
      },
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      // {
      //   id: 'tab-bar',
      //   type: 'tabs',
      // },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
        // title: 'resource#metadata',
      },
      {
        id: 'metadata-contenuti',
        type: 'metadata-dynamic',
        options: {
          accordion: true,
          dynamic: true
        }
      },
      {
        id: 'collection-bibliography',
        type: 'collection',
        grid: 1,
        title: 'Bibliografia',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
    ],
  },
} as ConfigMurucaResourceLayout;
